import { postDataAsync } from "./PortalApi";
import SignUpRequest from "interfaces/request/SignUpRequest";
import AuthResponse from "interfaces/response/AuthResponse";
import VerificationResponse from "interfaces/response/VerificationResponse";
import SignUpValidationRequest from "interfaces/request/SignUpValidationRequest";
import SignUpValidationResponse from "interfaces/response/SignUpValidationResponse";
import SignUpEmailVerificationCodeRequest from "interfaces/request/SignUpEmailVerificationCodeRequest";
import SignUpPhoneVerificationCodeRequest from "interfaces/request/SignUpPhoneVerificationCodeRequest";

export const requestUserSignUpAsync = async (data: SignUpRequest) => {
  const routeUrl = "SignUp/WithDefaultLicense";
  return await postDataAsync<SignUpRequest, AuthResponse>(routeUrl, data);
};

export const requestForSignUpValidationAsync = async (
  data: SignUpValidationRequest
) => {
  const routeUrl = "SignUp/Validation";
  return await postDataAsync<SignUpValidationRequest, SignUpValidationResponse>(
    routeUrl,
    data
  );
};

export const requestForSignUpEmailVerificationCodeAsync = async (
  data: SignUpEmailVerificationCodeRequest
) => {
  const routeUrl = "SignUp/Email/VerificationCode";
  return await postDataAsync<
    SignUpEmailVerificationCodeRequest,
    VerificationResponse
  >(routeUrl, data);
};

export const requestForSignUpPhoneVerificationCodeAsync = async (
  data: SignUpPhoneVerificationCodeRequest
) => {
  const routeUrl = "SignUp/Phone/VerificationCode";
  return await postDataAsync<
    SignUpPhoneVerificationCodeRequest,
    VerificationResponse
  >(routeUrl, data);
};
